import React, { useEffect, useState } from 'react';
import { Check } from 'lucide-react';

// "Místo instalace" picker on the machine detail: customer's own address or one of its sites.
const MachineSiteSelect = ({ machineId, customerId, siteId }) => {
  const [sites, setSites] = useState([]);
  const [value, setValue] = useState(siteId ?? '');
  const [state, setState] = useState(''); // '' | 'saving' | 'saved' | error message

  useEffect(() => { setValue(siteId ?? ''); }, [siteId]);
  useEffect(() => {
    if (!customerId) return;
    fetch(`/api/customers/${customerId}/sites`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : { data: [] }))
      .then((j) => setSites(j.data || []))
      .catch(() => setSites([]));
  }, [customerId]);

  const change = async (e) => {
    const next = e.target.value;
    const previous = value;
    setValue(next);
    setState('saving');
    try {
      const res = await fetch(`/api/machines/${machineId}/site`, {
        method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ site_id: next === '' ? null : Number(next) }),
      });
      const json = await res.json().catch(() => ({}));
      if (!res.ok || json.success === false) throw new Error(json.error || `Chyba ${res.status}`);
      setState('saved');
    } catch (err) {
      setValue(previous);
      setState(`Nepodařilo se uložit: ${err.message}`);
    }
  };

  return (
    <div>
      <select value={value} onChange={change} disabled={state === 'saving'} aria-label="Místo instalace"
        style={{ width: '100%', padding: '8px 10px', border: '1px solid #E0E0E0', borderRadius: '8px', fontSize: '14px', backgroundColor: '#FFF' }}>
        <option value="">Adresa zákazníka (sídlo)</option>
        {sites.map((s) => <option key={s.id} value={s.id}>{s.name}{s.city && s.city !== s.name ? ` – ${s.city}` : ''}</option>)}
      </select>
      {state === 'saved' && <span style={{ fontSize: '12px', color: '#388E3C', display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '4px' }}><Check size={12} /> Uloženo</span>}
      {state && !['saving', 'saved'].includes(state) && <span role="alert" style={{ fontSize: '12px', color: '#D32F2F', display: 'block', marginTop: '4px' }}>{state}</span>}
      {sites.length === 0 && <span style={{ fontSize: '12px', color: '#999', display: 'block', marginTop: '4px' }}>Provozovny se přidávají v detailu zákazníka.</span>}
    </div>
  );
};

export default MachineSiteSelect;
